/**
 * FeeCard Component
 * 배달료 카드
 */
import React from 'react';
import styles from '../../styles/shared/FeeCard.module.css';

interface FeeCardProps {
    deliveryFee: number;
}

export const FeeCard: React.FC<FeeCardProps> = ({ deliveryFee }) => {
    return (
        <div className={styles['fee-card']}>
            <div className={styles['fee-label']}>
                <span className={styles['fee-icon']}>💰</span>
                배달료
            </div>
            <div className={styles['fee-value']}>
                {(deliveryFee || 0).toLocaleString()}
                <span className={styles['fee-unit']}>원</span>
            </div>
        </div>
    );
};
